var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13 10.1C13 13.6346 10.3137 16.5 7 16.5C3.68629 16.5 1 13.6346 1 10.1C1 9.25128 1.15488 8.44115 1.43614 7.7C2.32622 5.35454 7 0.5 7 0.5C7 0.5 11.6738 5.35454 12.5639 7.7C12.8451 8.44115 13 9.25128 13 10.1Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensity);
export default __webpack_public_path__ + "static/media/intensity.9a187cf9a85fa23379b9797c5def8d7b.svg";
export { ForwardRef as ReactComponent };